module.exports = __webpack_public_path__ + "img/feats-2.751ab516.jpg";